import React, { memo, useState, useRef, useEffect } from "react";
import dot_green from "../img/dot_green.png";
import dot_red from "../img/dot_red.png";
import dot_yellow from "../img/dot_yellow.png";



const statusOptions = {
  Base: "Base",
  Intermediate: "Intermedio",
  Advanced: "Avanzato",
  Admin: "Amministratore",
};

export default memo(({ value, onValueChange, stopEditing }) => {
  const [isOpen, setIsOpen] = useState(false);
  const refContainer = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (refContainer.current && !refContainer.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const onClick = (newValue) => {
    onValueChange(newValue);
    setIsOpen(false);
    //stopEditing();
  };

  const boxStyle = {
    position: "relative",
    borderRadius: 5,
    border: "1px solid grey",
    backgroundColor: "#ffffff",
    padding: 10,
    textAlign: "center",
    height: "40px",
    width: "150px",
    display: "inline-flex",
    alignItems: "center",
    cursor: "pointer",
  };

  const dropdownStyle = {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    border: "1px solid grey",
    borderRadius: 10,
    padding: 10,
    display: isOpen ? "flex" : "none",
    flexDirection:"column",
    justifyContent: "center",
    gap: 10,
  };

  return (
    <div ref={refContainer} style={{ position: "relative", display: "inline-block" }}>
      <div style={boxStyle} onClick={() => setIsOpen((prev) => !prev)}>
        <span style={{width:"95px"}}>{statusOptions[value]}</span>
        <span style={{ marginLeft: isOpen ? "20px" : "20px" , fontSize: "20px" }}>▼</span>
      </div>
      <div style={dropdownStyle}>
        {Object.entries(statusOptions).map(([key, transcod]) => (
          <div className={transcod} onClick={()=>onClick(key)}>
            {transcod}
          </div>
        ))}
      </div>
    </div>
  );
});
